import { Stack } from '@mui/material';

import { useGetPlanningPeriodsQuery } from 'state/apiSlice';

import { BaseMonthPicker } from '../task_bar/TypicalMonthPicker';
import { DetourLabel } from './DetourLabel';

import styles from './WorkflowDetour.module.css';

export function useGetScenarioPeriodsQuery(project_slug, options) {
  const queryReturn = useGetPlanningPeriodsQuery(project_slug, options);
  if (queryReturn.data) {
    queryReturn.data = queryReturn.data.filter((v) => v.isDetourReady);
  }
  return queryReturn;
}

export function ScenarioMonthPicker({
  disabled = false,
}: {
  disabled?: boolean;
}) {
  return (
    <Stack display="flex" gap={0.5}>
      <DetourLabel lbl="Time Period" />
      <BaseMonthPicker
        classes={{ menuItem: styles.fS14, paper: styles.mL8 }}
        fullWidth
        querier={useGetScenarioPeriodsQuery as any}
        disabled={disabled}
      />
    </Stack>
  );
}
